import { useCallback, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import actions from 'redux/action'

interface HintModalInstance {
  openHintModal: (ChildrenComponent: any) => void
  closeHintModal: () => void
}

export default function useHintModal(): HintModalInstance {
  const dispatch = useDispatch()

  const openHintModal = useCallback(
    (ChildrenComponent: any) => {
      dispatch(actions.openHintModal(ChildrenComponent))
    },
    [dispatch]
  )

  const closeHintModal = useCallback(() => {
    dispatch(actions.closeHintModal())
  }, [dispatch])

  const instance = useMemo(() => {
    return {
      openHintModal,
      closeHintModal,
    }
  }, [closeHintModal, openHintModal])

  return instance
}
